import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8be5bd32"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-wrapper"
};
const _hoisted_2 = {
  class: "link-list"
};
const _hoisted_3 = {
  class: "text"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_6 = {
  class: "teacher-list"
};
const _hoisted_7 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CardHeader = _resolveComponent("CardHeader");

  const _component_TeacherCard = _resolveComponent("TeacherCard");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", {
    class: "teacher-main-wrapper",
    style: _normalizeStyle({
      background: $props.menu.backImage ? `url(${$props.menu.backImage})` : $props.menu.backColor ? $props.menu.backColor : 'url(https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202304/f347efaa101346a28c40b41bdc0cd9c7.png)'
    })
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_CardHeader, {
    link: `/teacherList.html?name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`
  }, {
    left: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.menu.module_name), 1)])]),
    right: _withCtx(() => [_hoisted_4, _hoisted_5]),
    _: 1
  }, 8, ["link"]), _createElementVNode("div", _hoisted_6, [$data.teacherList && $data.teacherList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.teacherList, teacherData => {
    return _openBlock(), _createBlock(_component_TeacherCard, {
      teacherData: teacherData,
      key: teacherData.teacher_id,
      menu: $props.menu,
      class: "teacher-card"
    }, null, 8, ["teacherData", "menu"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_Empty, {
    type: "people"
  })]))])])], 4);
}